import i18n from "@/locales";

export enum TraitAnimationType {
  Blink = 1,
  LipSync = 2,
}

export enum TraitAnimationPortraitType {
  EyesOpen = 1,
  EyesClosed = 2,
  MouthOpen = 3,
  MouthClosed = 4,
  HalfOpenMouth = 5,
}

export enum AnymateTheme {
  dark = "any-mate-dark",
  light = "any-mate-light",
}

export enum SorterEnum {
  HOT = "hot",
  NEW = "new",
}

export enum MateSearchSorterEnum {
  HOT = "hot",
  NEW = "new",
  POPULAR = "popular",
  TRENDING = "trending",
  Recommended = "recommended",
}

export enum SearchModeEnum {
  IMAGE = "image",
  CHARACTER = "character",
  MOMENT = "moment",
}

export enum ContentRatingEnum {
  SFW = 0,
  NSFW = 1,
}

export const useContentRatingText = (rating: ContentRatingEnum) => {
  switch (rating) {
    case ContentRatingEnum.SFW:
      return i18n.global.t("nsfw.sfw");
    case ContentRatingEnum.NSFW:
      return i18n.global.t("nsfw.nsfw");
    default:
      return "";
  }
};

export enum ReviewStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export enum UserSubscriptionType {
  Free = 1,
  Starter = 2,
  Premium = 3,
  Deluxe = 4,
}

export enum ReplyEntityType {
  GalGame = "galGame",
  Story = "story",
  StoryBook = "storyBook",
  Moment = "moment",
  Collection = "collection",
}
